import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tabs', 'contents'];

  static classes = ['on', 'off'];

  connect() {
    console.log(this);
  }

  onTab(event) {
    if (!event.target.hash) {
      return;
    }
    const selectedClass = event.target.hash;

    const tabs = this.tabsTarget.children;
    const contents = this.contentsTarget.children;

    for (const tab of tabs) {
      if (tab.children[0].hash === selectedClass) {
        if (this.hasOnClass && this.hasOffClass) {
          tab.classList.replace(this.offClass, this.onClass);
        } else {
          tab.classList.add('text-white', 'bg-coolgray-700');
        }
      } else {
        if (this.hasOnClass && this.hasOffClass) {
          tab.classList.replace(this.onClass, this.offClass);
        } else {
          tab.classList.remove('text-white', 'bg-coolgray-700');
        }
      }
    }

    for (const content of contents) {
      if (content.classList.contains(selectedClass)) {
        content.classList.remove('hidden');
      } else {
        content.classList.add('hidden');
      }
    }
  }
}
